"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _styles2 = require("../utilities/styles");
var _camelCase = _interopRequireDefault(require("../poly/camelCase"));
const _excluded = ["classes", "indicatorType", "indicatorColor", "customSelectColor"],
  _excluded2 = ["focusVisibleClassName", "root"];
const useClasses = (0, _styles.makeStyles)(({
  palette,
  breakpoints,
  accessibility: {
    highContrast
  },
  typography
}) => ({
  root: {
    opacity: 1,
    margin: '4px !important',
    letterSpacing: '.6px',
    whiteSpace: 'nowrap',
    maxWidth: 'initial',
    fontSize: typography.h5.fontSize,
    [breakpoints.down('md')]: {
      minWidth: 'auto'
    },
    '&:hover': {
      color: ({
        indicatorColor,
        customSelectColor
      }) => customSelectColor ? customSelectColor : palette.button.contained[indicatorColor].backgroundColor,
      [highContrast.mediaQuery('active')]: {
        color: 'Highlight !important',
        textDecoration: 'underline 2px'
      }
    }
  },
  defaultRoot: {
    [breakpoints.down('md')]: {
      paddingLeft: 0,
      paddingRight: 0
    },
    '&:first-child': {
      marginRight: '.4em',
      [breakpoints.only('sm')]: {
        marginRight: '.6em'
      }
    },
    '&:not(:first-child):not(:last-child)': {
      marginLeft: '.4em',
      marginRight: '.4em',
      [breakpoints.only('sm')]: {
        marginLeft: '.6em',
        marginRight: '.6em'
      }
    },
    '&:last-child': {
      marginLeft: '.4em',
      [breakpoints.only('sm')]: {
        marginLeft: '.6em'
      }
    }
  },
  defaultFocusVisible: {
    margin: '2px !important',
    color: ({
      indicatorColor,
      customSelectColor
    }) => customSelectColor ? customSelectColor : palette.button.text[indicatorColor].color,
    border: `2px solid ${palette.text.primary} !important`,
    outline: `2px solid ${palette.background.default} !important`,
    [highContrast.mediaQuery('active')]: {
      color: 'HighlightText !important',
      background: 'Highlight !important',
      '-ms-high-contrast-adjust': 'none',
      border: `2px solid Window !important`,
      outline: `2px solid WindowText !important`,
      zIndex: 1
    }
  },
  defaultSelected: {
    color: ({
      indicatorColor,
      customSelectColor
    }) => customSelectColor ? customSelectColor : palette.button.text[indicatorColor].color,
    [highContrast.mediaQuery('active')]: {
      color: 'HighlightText !important',
      background: 'Highlight !important',
      '-ms-high-contrast-adjust': 'none',
      '&:hover': {
        textDecoration: 'underline 2px',
        color: 'HighlightText !important'
      }
    }
  },
  pillRoot: {
    minWidth: 'initial',
    borderRadius: 10,
    color: palette.button.contained.tertiary.color,
    backgroundColor: palette.button.contained.tertiary.background,
    border: `1px solid ${palette.border.secondary}`,
    '&:first-child': {
      marginRight: '.15em',
      [breakpoints.up('md')]: {
        marginRight: '.5em'
      }
    },
    '&:not(:first-child):not(:last-child)': {
      marginLeft: '.15em',
      marginRight: '.15em',
      [breakpoints.up('md')]: {
        marginLeft: '.5em',
        marginRight: '.5em'
      }
    },
    '&:last-child': {
      marginLeft: '.15em',
      [breakpoints.up('md')]: {
        marginLeft: '.5em'
      }
    },
    '&:hover': {
      color: ({
        indicatorColor
      }) => palette.button.contained[indicatorColor].hover.color,
      backgroundColor: ({
        indicatorColor
      }) => palette.button.contained[indicatorColor].hover.background,
      borderColor: ({
        indicatorColor
      }) => palette.button.contained[indicatorColor].hover.borderColor
    }
  },
  pillSelected: {
    [highContrast.mediaQuery('active')]: {
      background: 'Highlight !important',
      color: 'HighlightText !important',
      '-ms-high-contrast-adjust': 'none',
      '&:hover': {
        [highContrast.mediaQuery('active')]: {
          textDecoration: 'underline 2px'
        }
      }
    },
    color: ({
      indicatorColor
    }) => palette.button.contained[indicatorColor].color,
    backgroundColor: ({
      indicatorColor
    }) => palette.button.contained[indicatorColor].background,
    borderColor: 'transparent',
    '&:hover, &:focus': {
      color: ({
        indicatorColor
      }) => palette.button.contained[indicatorColor].hover.color,
      backgroundColor: ({
        indicatorColor
      }) => palette.button.contained[indicatorColor].hover.background,
      borderColor: ({
        indicatorColor
      }) => palette.button.contained[indicatorColor].hover.borderColor,
      [highContrast.mediaQuery('active')]: {
        color: 'HighlightText !important'
      }
    }
  },
  pillFocusVisible: {
    margin: '2px !important',
    color: ({
      indicatorColor
    }) => palette.button.contained[indicatorColor].hover.color,
    backgroundColor: ({
      indicatorColor
    }) => palette.button.contained[indicatorColor].hover.background,
    border: `2px solid ${palette.background.default} !important`,
    outline: `2px solid ${palette.text.primary} !important`,
    [highContrast.mediaQuery('active')]: {
      color: 'HighlightText !important',
      background: 'Highlight !important',
      '-ms-high-contrast-adjust': 'none',
      margin: '2px !important',
      border: `2px solid Window !important`,
      outline: `2px solid WindowText !important`,
      zIndex: 1
    }
  },
  wrapper: (0, _extends2.default)({}, palette.button.labelBase)
}), {
  classNamePrefix: 'TCUITab'
});
const Tab = _ref => {
  let {
      classes,
      indicatorType,
      indicatorColor,
      customSelectColor
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const _classes = useClasses({
    indicatorColor,
    customSelectColor
  });
  const {
      focusVisibleClassName,
      root
    } = classes,
    restClasses = (0, _objectWithoutPropertiesLoose2.default)(classes, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_Tab.default, (0, _extends2.default)({}, rest, {
    classes: (0, _styles2.mergeClasses)({
      root: (0, _clsx.default)(_classes.root, _classes[(0, _camelCase.default)([indicatorType, 'root'])], root),
      selected: _classes[(0, _camelCase.default)([indicatorType, 'selected'])],
      wrapper: _classes.wrapper,
      indicator: _classes[(0, _camelCase.default)([indicatorType, 'indicator'])]
    }, restClasses),
    focusVisibleClassName: (0, _clsx.default)(_classes[(0, _camelCase.default)([indicatorType, 'focusVisible'])], focusVisibleClassName)
  }));
};
Tab.propTypes = {
  classes: _propTypes.default.object,
  indicatorType: _propTypes.default.oneOf(['default', 'pill']),
  indicatorColor: _propTypes.default.string,
  customSelectColor: _propTypes.default.string
};
Tab.defaultProps = {
  classes: {},
  indicatorType: 'default',
  indicatorColor: 'primary',
  customSelectColor: null
};
var _default = exports.default = Tab;